module.exports = __webpack_public_path__ + "static/img/yiyuan_logo.646dcf38.png";